<template>
<div id="coupon-explain">
  <el-dialog
    v-model="showCouponExplain"
    top="50%"
    :title="title"
    custom-class="coupon-explain-modal"
    :close-on-click-modal="false"
    @close="closeCouponExplain">

    <div class="coupon-explain-box">
      <ul class="coupon-explain-content" v-if="coupon.product_name && coupon.product_name.length > 0">
        <li v-for="(v,index) in coupon.product_name" :key="index" >{{ v }}</li>
      </ul>
      <div class="coupon-explain-desc" v-else>{{coupon.desc}}</div>
    </div>
  </el-dialog>
</div>
</template>

<script>
export default {
  name: 'coupon-explain',
  props: {
    // 是否打开
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    coupon: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      showCouponExplain: this.value, // 是否展示
    };
  },
  computed: {
    title() {
      return (this.coupon.product_name && this.coupon.product_name.length > 0) ? this.coupon.desc : '限指定国家使用';
    },
  },
  watch: {
    value(newVal) {
      this.showCouponExplain = newVal;
    },
  },

  methods: {
    closeCouponExplain() {
      this.$emit('couponExplainClose', false);
    },
  },
};
</script>

<style lang="less">
#coupon-explain {
  .coupon-explain-modal {
    transform: translate(-50%,-50%);
    width: 600px;
    box-shadow: 0px 8px 20px 0px
		rgba(0, 0, 0, 0.2);
	  border-radius: 4px;
    .el-dialog__header {
      padding: 0;
      height: 50px;
      .el-dialog__title {
        display: block;
        line-height: 50px;
        color: #333333;
        text-align: center;
        border-bottom: 1px solid #f5f5f5;
      }
      .el-dialog__headerbtn {
        position: relative;
        bottom: 35px;
        right: 20px;
      }
    }
    .el-dialog__body {
      padding: 0;
      .coupon-explain-box {
        .coupon-explain-content {
          padding: 15px 30px 15px 50px;
          list-style-type: disc;
          max-height: 590px;
          overflow: auto;
          li {
            font: 14px/24px "微软雅黑";
            padding: 5px 0;
            color: #6f6f6f;
          }
        }
        .coupon-explain-desc {
          padding: 15px 30px;
          max-height: 590px;
          overflow: auto;
          font: 14px/24px "微软雅黑";
          color: #6f6f6f;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/coupon/coupon-explain.vue